export enum TransportType {
    Walk = 'Walk',
    Bicycle = 'Bicycle',
    Drive = 'Drive'
}
